
var swiperYT = new Swiper('.swiper-youtube', {
  slidesPerView: 1,
  spaceBetween: 20,
  allowTouchMove: true,
  centeredSlides: false,
  simulateTouch:true,
  rewind: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    470: {
      slidesPerView: 2,
      spaceBetween: 20,
      centeredSlides: false,
    },
    715: {
      slidesPerView: 3,
      spaceBetween: 20,
      centeredSlides: false,
    },
    960: {
      slidesPerView: 4,
      spaceBetween: 20,
      centeredSlides: false,
    },
  },
});

var swiperQuote = new Swiper(".swiper-quote", {
  slidesPerView: 'auto',
  spaceBetween: 20,
  speed: 8000,
  allowTouchMove: false,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
    stopOnLastSlide: false,
  },
  loop: true,
});

var swiperScroll = new Swiper(".swiper-scroll", {
  slidesPerView: 'auto',
  spaceBetween: 40,
  speed: 8000,
  allowTouchMove: false,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
    stopOnLastSlide: false,
    // reverseDirection: true,
  },
  loop: true,
});

var swiper = new Swiper(".swiper-select", {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiper2 = new Swiper(".swiper-disp", {
  spaceBetween: 10,
  thumbs: {
    swiper: swiper,
  },
});
/*

// Width adjustment function for feature slider
function adjustFeatureContentWidth() {
    var features = document.querySelectorAll('.feature-slide');
    features.forEach(function(feature) {
        var imageWidth = feature.querySelector('.feature-image img').offsetWidth;
        var content = feature.querySelector('.feature-content');
        content.style.width = imageWidth + 'px';
    });
}*/
/*
// Invoke the width adjustment function on DOMContentLoaded
document.addEventListener("DOMContentLoaded", adjustFeatureContentWidth);
var swiperFeat = new Swiper('.swiper-features', {
  slidesPerView: 1,
  spaceBetween: 10,
  allowTouchMove: true,
  centeredSlides: false,
  simulateTouch:true,
  rewind: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1024: {
      spaceBetween: 20,
      centeredSlides: false,
    },
    1300: {
      spaceBetween: 100,
      centeredSlides: false,
    },
    1600: {
      spaceBetween: 200,
      centeredSlides: false,
    },
    2000: {
      spaceBetween: 400,
      centeredSlides: false,
    },
    2500: {
      spaceBetween: 650,
      centeredSlides: false,
    },
    3000: {
      spaceBetween: 900,
      centeredSlides: false,
    },
    3500: {
      spaceBetween: 1150,
      centeredSlides: false,
    },
    4000: {
      spaceBetween: 1400,
      centeredSlides: false,
    },
  },
  
});
*/
/*
window.addEventListener('resize', function() {
  swiperYT.update();
  swiperQuote.update();
  swiperScroll.update();
  swiper.update();
  swiperFeat.update();
    adjustFeatureContentWidth(); // Invoke the width adjustment function on window resize

});
*/
// Invoke the width adjustment function on window resize
/*window.addEventListener("resize", adjustFeatureContentWidth);*/
/*
// Update the swiper instance for .swiper-features on window resize
if (typeof swiperFeat !== "undefined") {
    window.addEventListener("resize", function() {
        swiperFeat.update();
    });
}
*/